import axios from "axios";
import { authHeader, getValidToken } from "../utils/helper";
import { API_URL } from "../utils/helper";
import { config } from "../utils/config";

export const getUserDetail = (onSuccess = () => {}) => {
  const apiUrl = config.URL.GET_USER_TOKEN;
  return async () => {
    const token = await getValidToken();
    axios
      .get(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when fetching user detail", e);
      });
  };
};

export const fetchUserById = (userId,onSuccess = () => {}) => {

  const apiUrl = `${config.URL.FETCH_USER_BY_ID}${userId}`;

  return async () => {
    const token = await getValidToken();
    axios
      .get(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error in fetching user", e);
      });
  };
};
